module.exports = __webpack_public_path__ + "static/media/moi.56df0c7c.jpeg";